// extracted by mini-css-extract-plugin
export var bottomBorder = "styles-module--bottomBorder--253d0";
export var lightScheme = "styles-module--lightScheme--e12ad";